import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
  {
    pid: 2,
    lpSymbol: 'BUSD-BNB LP',
    lpAddresses: {
      97: '',
      56: '0x58F876857a02D6762E0101bb5C46A8c1ED44Dc16',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 0,
    lpSymbol: 'ZLT-BNB LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      56: '0xe832F83D1708026E82c0127a310D64BF7DC74e8d',
      // 56: '0x87E58e46bE9d00793Ed1CF7c999c51B71923BDa7',
    },
    token: serializedTokens.zlt,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 3,
    lpSymbol: 'ZLT-BUSD LP',
    lpAddresses: {
      97: '',
      56: '0xCdEE9978Ac7549c755B58849Ed7E1648EFaC6cA7',
      // 56: '0x87E58e46bE9d00793Ed1CF7c999c51B71923BDa7',
    },
    token: serializedTokens.zlt,
    quoteToken: serializedTokens.busd,
  },

]

export default farms
